__turbopack_context__.v({
  "cursorAnim": "style-module-scss-module__zmi3Dq__cursorAnim",
  "cursorImage": "style-module-scss-module__zmi3Dq__cursorImage",
  "cursorWrapper": "style-module-scss-module__zmi3Dq__cursorWrapper",
  "rightDirection": "style-module-scss-module__zmi3Dq__rightDirection",
});
